module.exports = __webpack_public_path__ + "img/trash.8b89c2c1.svg";